import script from "./aborigines.vue?vue&type=script&setup=true&lang=js"
export * from "./aborigines.vue?vue&type=script&setup=true&lang=js"

import "./aborigines.vue?vue&type=style&index=0&id=10d715c7&lang=scss"

const __exports__ = script;

export default __exports__